// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import VueResource from "vue-resource";
import App from "./App";
import router from "./router";
import store from "./api/store";
import common from "./api/common";
/**全局组件 */
import PurchaseDialog from "./components/global/purchaseDialog";
import Toast from "./components/global/toast";
import Loading from "./components/global/loading";
import Dialog from "./components/global/dialog";
import Router from "./components/global/router";
import api from "./api";
import filters from "./utils/filters";

import Pages from "./router/Pages";

import { DatePicker } from "element-ui";

import Vant from "vant";
import "vant/lib/index.css";

Vue.use(Vant);
Vue.use(DatePicker);

//解决IE没有console对象的bug
window.console =
  window.console ||
  (function() {
    var c = {};
    c.log = c.warn = c.debug = c.info = c.error = c.time = c.dir = c.profile = c.clear = c.exception = c.trace = c.assert = function() {};
    return c;
  })();
// requestAniFrame兼容问题
window.requestAniFrame = (function() {
  return (
    window.requestAnimationFrame ||
    // Older versions Chrome/Webkit
    window.webkitRequestAnimationFrame ||
    // Firefox < 23
    window.mozRequestAnimationFrame ||
    // opera
    window.oRequestAnimationFrame ||
    // ie
    window.msRequestAnimationFrame ||
    function(callback) {
      return window.setTimeout(callback, 1000 / 60);
    }
  );
})();

require("./CommonComponents");

Vue.config.productionTip = false;

Vue.use(VueResource);

filters.init();

/**全局组件 */
Vue.use(PurchaseDialog);
Vue.use(Toast);
Vue.use(Loading);
Vue.use(Dialog);
Vue.use(Router);

var GetQueryString = function(name) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  var r = window.location.search.substr(1).match(reg);
  if (r != null) return unescape(r[2]);
  return null;
};

/* eslint-disable no-new */

//是否找到公开页面
var isPublicPageFound = false;

if (window.location.pathname.toLocaleLowerCase().startsWith("/pages/public/")) {
  var component = null;
  Pages.forEach(page => {
    if (
      window.location.pathname
        .toLocaleLowerCase()
        .startsWith(page.path.toLocaleLowerCase())
    ) {
      component = page.component;
    }
  });

  if (!!component) {
    isPublicPageFound = true;
    new Vue({
      el: "#app",
      router,
      components: { App: component },
      template: "<App/>",
    });
  }
}

// //开始挂载
// new Vue({
//   el: '#app',
//   router,
//   components: { App },
//   template: '<App/>'
// })

//如果找到公开页面，则选择需要登录的页面
if (!isPublicPageFound) {
  api.user.getPersonalInfo(
    user => {
      store.loginedUser = user;

      // 开发用，开发完成记得注释
      // store.loginedUser.easyUser = true

      if (!GetQueryString("shareToken")) {
        var url = location.pathname + location.search;
        if (location.search.indexOf("?") >= 0) {
          url +=
            "&shareToken=" + encodeURIComponent(store.loginedUser.shareToken);
        } else {
          url +=
            "?shareToken=" + encodeURIComponent(store.loginedUser.shareToken);
        }
        location.replace(url);
      }
      //设置shareToken：定时检查，如果发现token不一致则进行替换
      // setInterval(()=>{
      //   var newHash = '#'+store.loginedUser.shareToken;
      //   if(newHash != location.hash){
      //     // location.replace(location.pathname+location.search+'&shareToken'+store.loginedUser.shareToken);
      //   }

      // }, 1000);
      //开始挂载
      new Vue({
        el: "#app",
        router,
        components: { App },
        template: "<App/>",
      });
    },
    () => {
      //未登录，执行自动登录
      //1. 获取当前地址
      var pageUrl =
        document.location.protocol +
        "//" +
        location.hostname +
        location.pathname +
        location.search;
      //2. 获取token
      var shareToken = GetQueryString("shareToken");
      if (shareToken) {
        //3.获取跳转登录的地址
        api.user.getShareBackUrl(
          pageUrl,
          shareToken,
          res => {
            if (!!res.url) {
              //4. 执行登录
              window.location = res.url;
            } else {
              alert("商户未配置自动登录地址");
              if (common.defaultLoginUrl) {
                window.location = common.defaultLoginUrl;
              }
            }
          },
          res => {
            alert(res.msg);
            if (common.defaultLoginUrl) {
              window.location = common.defaultLoginUrl;
            }
          }
        );
      } else {
        alert("无法登录，请刷新重试");
        // if(common.defaultLoginUrl){
        //   window.location = common.defaultLoginUrl
        // }
      }
    }
  );
}



// WEBPACK FOOTER //
// ./src/main.js